import { useRef } from 'react';

/**
 * Runs a callback exactly once before the first render, standing in for a class constructor. Guards on a ref so later renders return immediately without invoking the callback again.
 *
 * @param callBack - Function to run once on the first render.
 * @returns Nothing.
 */
const useConstructor = (callBack: (...args: any[]) => any = () => {}) => {
  const hasBeenCalled = useRef(false);
  if (hasBeenCalled.current) return;
  callBack();
  hasBeenCalled.current = true;
};

export default useConstructor;
